import { Box, useTheme } from '@mui/material'

const Feed = ({children}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box 
      flex={1} 
      sx={{
        height: '99vh',
        overflow: 'hidden',
        border:0,
        borderRadius:2,
        overflowX:'hidden',
        paddingRight:1,
        backgroundColor: isDarkMode ? '#0a0a12' : 'transparent'
      }} 
      className='bodyScreen'
    >
      {children}
    </Box>
  )
}

export default Feed